import { render } from "./FormatAlignRight.vue?vue&type=template&id=63f4e8b3"
import script from "./FormatAlignRight.vue?vue&type=script&lang=js"
export * from "./FormatAlignRight.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\merk\\Documents\\_kwork\\virginia79\\lk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__